import React from "react";
import { useNavigate } from "react-router-dom";
import Button from '../components/Button';

export default function Recomendaciones() {
  const navigate = useNavigate();

  return (
    <div className="p-4 max-w-xl mx-auto flex flex-col gap-4">

      {/* Encabezado */}
      <div className="flex items-center justify-center">
        <h3 className="font-bold text-center">RECOMENDACIONES</h3>
      </div>

      {/* Recomendaciones */}

      <div className="flex flex-col gap-4 mt-2 font-semibold text-white">
        <Button onClick={() => navigate("/recomendacion/recomendaciones-generales")}>
          Recomendaciones generales
        </Button>

        <Button onClick={() => navigate("/recomendacion/recomendaciones-dieteticas-generales")}>
          Recomendaciones dietéticas generales
        </Button>

        <Button onClick={() => navigate("/recomendacion/recomendaciones-dieteticas-espesantes")}>
          Recomendaciones dietéticas sobre el uso de espesante
        </Button>

        <Button onClick={() => navigate("/recomendacion/recomendaciones-dieteticas-nectar")}>
          Recomendaciones dietéticas características de la viscosidad néctar
        </Button>

        <Button onClick={() => navigate("/recomendacion/recomendaciones-dieteticas-pudin")}>
          Recomendaciones dietéticas características de la consistencia pudín
        </Button>
      </div>
    </div>
  );
}